// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__15BTM","selected":"Chip_selected__1wbYK"};